import { useState } from "react"

const data = [
    {
      title: 'Corporate Social Responsibility Policy',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/CSR_Policy.pdf',
    },
    {
      title: 'Familiarization Programme Of ID',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Familiarization_Programme_of_ID.pdf',
    },
    {
      title: 'Nomination And Remuneration Policy',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Nomination_and_Remuneration_Policy.pdf',
    },
    {
      title: 'Vigil Mechanism Whistler Blower Policy',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Vigil_Mechanism_Whistler_Blower_Policy.pdf',
    },
    {
      title: 'Code Of Conduct For BOD And SMP',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Code_of_Conduct_for_BOD_and_SMP.pdf',
    },
    {
      title: 'Code Of Practice And Procedure For UPSI',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Code_of_Practice_and_procedure_for_UPSI.pdf',
    },
    {
      title: 'Criteria Or Policy For Making Payments To NED',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Criteria_or_Policy_for_making_payments_to_NED.pdf',
    },
    {
      title: 'Policy On Materiality Of Related Party Transactions',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Policy_on_Materiality_of_Related_Party_Transactions.pdf',
    },
    {
      title: 'Policy On Preservation And Archival Of Documents',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Policy_on_Preservation_and_Archival_of_Documents.pdf',
    },
    {
      title: 'Policy On Prevention Of Sexual Harrasement At Workplace POSH',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Policy_on_prevention_of_Sexual_Harrasement_at_workplace_POSH.pdf',
    },
    {
      title: 'Policy On Determination Of Materiality',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Policy_on_Determination_of_Materiality.pdf',
    },
    {
      title: 'Terms Conditions Of Appointment Of Independent Directors',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Terms_conditions_of_Appointment_of_Independent_Directors.pdf',
    },
    {
      title: 'Prohibition Of Insider Trading Policy',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Prohibition_of_Insider_Trading_Policy.pdf',
    },
    {
      title: 'Materiality Policy',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/policies/Materiality_Policy.pdf',
    },
    // {
    //   title: 'Standalone Financials FY23-24',
    //   // month : months[0],
    //   files: 'https://assets.bharatrohan.in/finances/FS_FY23-24.pdf',
    // },
]

export default function Policy01() {
    const [selected, setSelected] = useState<number>(0)
    const isMobile = window.innerWidth<1024;
    console.log("yo ho is mobile hai",isMobile);
    
    return (
        <div className="py-8 lg:pb-10"> {/* Replaceable line is down */}
      {/* <div className="py-8 bg-cream lg:pb-10"></div> */}
      {/* <div className="w-container-lg"> */}
        <div className="flex flex-col lg:flex-row items-start gap-x-12 xl:gap-x-16 2xl:gap-x-20 gap-y-6 md:gap-y-12">
          <div className="grid  w-full blade-top-padding-sm lg:pt-0 lg:w-[100%] gap-y-4 lg:gap-y-6 flex-col">
            {data.map((item, index) => (
              <div className='flex justify-around sm:flex'>
                <div className="md:w-[70%] sm:w-2" key={index}>
                  <div
                    onClick={() => {
                      setSelected(index)
                    }}
                    className={`flex w-full py-4 border px-4 sm:px-6 md:px-8 lg:px-4 xl:px-6 border-green items-center justify-between cursor-pointer transition-al duration-1000 ${
                      selected === index
                        ? 'bg-transparent cursor-auto pt-6'
                        : 'bg-transparent'
                    }`}
                  >
                    <a href={item.fileUrl} target='_blank' className="grid w-full grid-cols-[2.5rem_1fr_auto] sm:grid-cols-[3rem_1fr_auto] xl:grid-cols-[4rem_1fr_auto]">
                    <span
                      className={`text-lg lg:text-xl 2xl:text-xl opacity-25 font-bold transition-all duration-1000 ${
                        selected === index ? 'text-black' : 'text-black'
                      }`}
                    >{index >= 9 ? `${index + 1}` : `0${index + 1}`}</span>
                      <h4
                        className={`${
                          selected === index ? 'text-green' : 'text-green'
                        } font-semibold text-left transition-all duration-1000 self-center 2xl:text-xl overflow-hidden`}
                      >
                        <div
                          className={`inline-block whitespace-nowrap ${(isMobile && item.title.length > 25)? 'animate-slide 2xl:animate-none px-2' : item.title.length>40?'animate-slide':'w-80'}`} 
                          // style={{ paddingLeft: item.title.length > 10 ? '100%' : 0 }} 
                          >

                          {item.title}
                          </div>
                      </h4>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      {/* </div> */}
    </div>
    )
} 